import { render, staticRenderFns } from "./waterBottle.vue?vue&type=template&id=5109f364"
import script from "./waterBottle.vue?vue&type=script&lang=js"
export * from "./waterBottle.vue?vue&type=script&lang=js"
import style0 from "./waterBottle.vue?vue&type=style&index=0&id=5109f364&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports